import React from 'react';
import { motion } from 'framer-motion';
export function TheAskSection() {
  return <section id="ask" className="pt-10 pb-16 relative" data-id="element-111">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-112">
        <div className="mb-8 relative" data-id="element-113">
          <h2 className="text-5xl md:text-6xl font-bold mb-3 tracking-tight" data-id="element-114">
            HOW YOU CAN HELP
          </h2>
          <div className="flex gap-2 mt-4" data-id="element-115">
            {['#FF0000', '#FF8800', '#FFDD00', '#00DD00', '#0088FF', '#8800FF'].map((color, i) => <div key={i} className="h-2 flex-1" style={{
            backgroundColor: color
          }} data-id="element-116" />)}
          </div>
        </div>
        <div className="border-4 border-black p-6 bg-white mb-6 relative" data-id="element-117">
          <div className="space-y-4 text-base leading-relaxed" data-id="element-118">
            <p className="font-bold text-lg" data-id="element-119">
              This is a movement, a company, a creative rebellion, and a
              business model — all at once.
            </p>
            <p data-id="element-120">
              If I don't build this movement, someone less ethical will. The
              future belongs to communities, not platforms.
            </p>
            <p data-id="element-121">
              I want to mix activism, art, and tech into something ethical and
              profitable — no compromises.
            </p>
            <p className="font-bold" style={{
            color: '#8800FF'
          }} data-id="element-122">
              I'm here to build safety, confidence, purpose and financial
              stability — in public, with humor.
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-4 mb-8" data-id="element-123">
          {[{
          title: 'MENTOR',
          desc: "You've built ethical businesses. You can open doors. Share what you've learned. Help me avoid the mistakes you made.",
          icon: '💡',
          color: '#0088FF',
          commitment: 'TIME & INTRODUCTIONS'
        }, {
          title: 'SUPPORT',
          desc: 'You believe in this mission. Sliding scale donations help me keep building without selling out. Every bit matters.',
          icon: '🤝',
          color: '#00DD00',
          commitment: '$500-$5,000'
        }, {
          title: 'INVEST',
          desc: 'After Kickstarter proves demand. Join the Friends & Family round. Be part of building infrastructure that puts creators first.',
          icon: '💰',
          color: '#8800FF',
          commitment: '$25,000+'
        }].map((item, i) => <motion.div key={i} className="border-4 border-black bg-white overflow-hidden relative" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-124">
              <div className="p-3 text-center" style={{
            backgroundColor: item.color
          }} data-id="element-125">
                <div className="text-3xl mb-1" data-id="element-126">{item.icon}</div>
                <h3 className="text-lg font-bold" data-id="element-127">{item.title}</h3>
              </div>
              <div className="p-5" data-id="element-128">
                <p className="text-sm mb-3" data-id="element-129">{item.desc}</p>
                <div className="border-t-2 border-black pt-3" data-id="element-130">
                  <div className="text-xs font-bold text-center" data-id="element-131">
                    {item.commitment}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
        <div className="border-4 border-black p-6 bg-white text-black mb-8 relative" data-id="element-132">
          <h3 className="text-xl font-bold mb-4" data-id="element-133">
            WANT IN ON THE FRIENDS & FAMILY ROUND?
          </h3>
          <div className="space-y-4 mb-6" data-id="element-134">
            {[{
            step: '1',
            text: "Email me. Tell me why you believe in this — not just the business, but the mission. I want angels who get what we're building here.",
            color: '#00DD00'
          }, {
            step: '2',
            text: "We'll hop on a call. I want to understand your story, what drives you, why backing ethical creator infrastructure matters to you.",
            color: '#0088FF'
          }, {
            step: '3',
            text: "If it clicks, you're in. $25,000+. Early access. Direct line to me. You help shape what comes next.",
            color: '#8800FF'
          }].map((item, i) => <div key={i} className="flex items-start" data-id="element-135">
                <div className="w-8 h-8 flex items-center justify-center font-bold text-black mr-3 flex-shrink-0 text-sm border-2 border-black" style={{
              backgroundColor: item.color
            }} data-id="element-136">
                  {item.step}
                </div>
                <span className="text-base leading-relaxed" data-id="element-137">{item.text}</span>
              </div>)}
          </div>
          <motion.a href="mailto:dunjaslazic@gmail.com?subject=I want to invest" target="_blank" rel="noopener noreferrer" className="w-full py-4 text-black font-bold text-base border-4 border-black relative overflow-hidden block text-center no-underline" style={{
          backgroundColor: '#8800FF'
        }} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-138">
            JOIN THE ROUND
          </motion.a>
        </div>
      </motion.div>
    </section>;
}